import { useSelector } from 'react-redux';
import { root } from 'shared/selectors/config';
import { featureFlagsSelector } from '../../selectors/config';

export const useConfig = () => useSelector(root);

export const useFeatureFlags = () => useSelector(featureFlagsSelector);
